import type { Point } from "@turf/helpers";
import { SelectionFeature, SelectionType } from "src/js/stores/map/store";

export function isPointSelectionType(selection: SelectionFeature | undefined): selection is SelectionFeature<Point> {
  return selection?.type === SelectionType.POINT;
}
